import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

function imageCarousel() {

    let sliders = document.querySelectorAll('.js-image-carousel')
    let prev = document.querySelectorAll('.js-image-carousel .swiper-button-prev')
    let next = document.querySelectorAll('.js-image-carousel .swiper-button-next')
    let pagination = document.querySelectorAll('.js-image-carousel .swiper-pagination')

    sliders.forEach((slider, index)=>{
      // this bit checks if there's more than 1 slide, if there's only 1 it won't loop
      let sliderLength = slider.children[0].children.length
      let result = (sliderLength > 1) ? true : false

      const imageCarousel = new Swiper(slider, {
        modules: [Navigation, Pagination, Autoplay],
        observer: true, 
        observeParents: true,
        loop: false,
        draggable: true,
        navigation: {
          nextEl: next[index],
          prevEl: prev[index],
        },
        pagination: {
          el: pagination[index],
          type: 'bullets',
          clickable: true,
        },
        allowTouchMove: true,
        effect: 'slide',
        spaceBetween: 20,
        slidesPerView: 1,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
      });

    }); 
    
  
}


export default imageCarousel;
